export default __webpack_public_path__ + "static/media/customer_analytics_img.25625476.png";